import { Injectable, inject } from '@angular/core';
import {
  CoreMobiResourceType,
  selectorCoreNavigateToResourceStackLastItemType
} from '@bepatient/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { CategoryApiService } from './category-api.service';
import {
  CategoryActionLoadCategoryFailed,
  CategoryActionLoadCategorySuccess,
  CategoryActions,
  CategoryActionTypes
} from './category.actions';

@Injectable()
export class CategoryEffects {
  private store$ = inject<Store<any>>(Store);
  private actions$ = inject(Actions);
  private categoryApiService = inject(CategoryApiService);

  loadCategory$: Observable<CategoryActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryActionTypes.LOAD_CATEGORY),
      withLatestFrom(
        this.store$.select(
          selectorCoreNavigateToResourceStackLastItemType(
            CoreMobiResourceType.CATEGORY
          )
        ),
        (action, item) => item.href
      ),
      switchMap(href =>
        this.categoryApiService.loadCategory(href).pipe(
          map(res => new CategoryActionLoadCategorySuccess(res)),
          catchError(() => of(new CategoryActionLoadCategoryFailed()))
        )
      )
    )
  );
}
